import VibrateBase from "./vibrate.base";
import BridgeVibrate from "../bridge/bridge.vibrate";

export default class VibrateApp extends VibrateBase {
  
  private bridge: BridgeVibrate;
  
  constructor() {
    super();
    this.bridge = new BridgeVibrate();
  }

  public override async vibrate(_pattern: number | number[]): Promise<boolean> {
    return this.bridge.vibrateAsync(_pattern);
  }
}